import React from 'react';
import PropTypes from 'prop-types';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';
import Separator from '../../_commons/atoms/Separator';
import { useTranslation } from '@front10/utils';

const ItemContainer = (props) => {
  const {
    text,
    subText,
    showParenthesis,
    showText,
    showSubText,
    showSeparator,
    separatorProps,
    showLabelText,
    labelKey,
    labelTextProps
  } = props;
  const translate = useTranslation();
  let secondary = subText;
  if (showParenthesis) {
    secondary = `(${subText})`;
  }

  return (
    <Box textAlign={'center'} {...props}>
      <Box>
        {showLabelText && labelKey && (
          <Text type="span" {...labelTextProps}>
            {translate(labelKey, 'Flights to')}
          </Text>
        )}
        {showText && text && <Text type="span">{text}</Text>}
        {showSeparator && <Separator {...separatorProps} content="" />}
        {showSubText && subText && <Text type="span">{secondary}</Text>}
      </Box>
    </Box>
  );
};

ItemContainer.propTypes = {
  /**
   * text
   */
  text: PropTypes.string,
  /**
   * subText
   */
  subText: PropTypes.string,
  /**
   * labelKey
   */
  labelKey: PropTypes.string,
  /**
   * showParenthesis
   */
  showParenthesis: PropTypes.bool,
  /**
   * showLabelText
   */
  showLabelText: PropTypes.bool,
  /**
   * showText
   */
  showText: PropTypes.bool,
  /**
   * showSubText
   */
  showSubText: PropTypes.bool,
  /**
   * showSeparator
   */
  showSeparator: PropTypes.bool,
  /**
   * separatorProps
   */
  separatorProps: PropTypes.objectOf(PropTypes.any),
  /**
   * separatorProps
   */
  labelTextProps: PropTypes.objectOf(PropTypes.any)
};

ItemContainer.defaultProps = {
  text: '',
  labelKey: 'cmp-image-container-label-text',
  subText: '',
  showLabelText: false,
  showParenthesis: false,
  showText: true,
  showSubText: false,
  showSeparator: false,
  separatorProps: {},
  labelTextProps: {
    marginRight: '1'
  }
};

ItemContainer.componentName = 'ItemContainer';

export default ItemContainer;
